<h2 mat-dialog-title>{{id===-1?'Новый проект':'Редактировать проект'}}</h2>

<mat-dialog-content>
    <mat-tab-group [dynamicHeight]="true" [(selectedIndex)]="selectedTabIndex">
        <mat-tab label="Основные сведения">
 

    <mat-form-field [formGroup]="form" appearance="fill">
        <mat-label>Уровень доступа</mat-label>
        <mat-select formControlName="security_level">
            <mat-option *ngFor="let security_level of security_levels" [value]="security_level">{{security_level.ShortTitle}}</mat-option>
        </mat-select>
    </mat-form-field>
    <br>
    <mat-form-field [formGroup]="form" class="example-full-width"  [appearance]="id !== -1 ? 'fill' : 'legacy'">
        <mat-label>Краткое описание</mat-label>
        <input name="st_name" formControlName="short_title" matInput  value="" required>
    </mat-form-field>
    <br>
    <mat-form-field [formGroup]="form" class="example-full-width"  [appearance]="id !== -1 ? 'fill' : 'legacy'">
        <mat-label>Исполнитель</mat-label>
        <input formControlName="executor" matInput  value="" required>
    </mat-form-field>
    <br>
    <mat-form-field [formGroup]="form" class="example-full-width"  [appearance]="id !== -1 ? 'fill' : 'legacy'">
        <mat-label>Заказчик</mat-label>
        <input formControlName="customer" matInput  value="" required>
    </mat-form-field>
    <br>
    <mat-form-field [formGroup]="form" class="example-full-width"  [appearance]="id !== -1 ? 'fill' : 'legacy'">
        <mat-label>Описание</mat-label>
        <textarea cdkTextareaAutosize formControlName="description" matInput  value="" required></textarea>
    </mat-form-field>
    <br>
    <mat-form-field appearance="fill">
        <mat-label>Изменение дат</mat-label>
        <mat-date-range-input [formGroup]="form" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Start date">
            <input matEndDate formControlName="end" placeholder="End date">
        </mat-date-range-input>
        <mat-hint>д/м/г – д/м/г</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
        </mat-tab>
        <mat-tab label=" Этапы испытаний " [disabled]="id===-1">
            <stages [project_id]="this.id" ></stages>
        </mat-tab>
</mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="mat-raised-button" (click)="close()">Закрыть</button>
    <button class="mat-raised-button mat-primary" (click)="save()" [disabled]="form.get('security_level').value.ID === -1 || form.get('short_title').value.length < 1 || form.get('executor').value.length < 1 || form.get('customer').value.length < 1 || form.get('description').value.length < 1 || !form.get('start').value || !form.get('end').value ">
        Сохранить
    </button>
</mat-dialog-actions>

